import React from "react";
import { fetchCarStartData, RenderCarStart } from "./RenderCarStart";
import { fetchGlebaStartData, RenderGlebaStart } from "./RenderGlebaStart";
import { operationSaveGleba, operationSaveGlebaWithoutCar } from "~/api";

const starts = {
  car: {
    fetch: fetchCarStartData,
    render: props => <RenderCarStart {...props} />,
    save: params => operationSaveGleba(params),
    options: {
      descricaoId: "operacao-gleba-car-descricao",
      continueSaveButtonId: "cadastrar-gleba",
      hasCar: true,
      canDrawOnMap: true,
      canUploadFile: true,
      fileFormats: [".kml", ".zip"]
    }
  },
  gleba: {
    fetch: fetchGlebaStartData,
    render: props => <RenderGlebaStart {...props} />,
    save: params => operationSaveGlebaWithoutCar(params),
    options: {
      descricaoId: "operacao-gleba-descricao",
      continueSaveButtonId: "cadastrar-gleba",
      hasCar: false,
      canDrawOnMap: false,
      canUploadFile: true,
      fileFormats: [".kml"]
    }
  }
};

export default function getAreaStartForm(operationStart) {
  const startKeys = Object.keys(starts);

  if (!startKeys.includes(operationStart)) return null;

  return starts[operationStart];
}
